import styled from "styled-components";
import { motion } from "framer-motion";

import Button from "../Button";
import { IconKey } from "../../models/client";
import { Position } from "../../models/client/position";

interface ThreeSixtyInteractionToolTipProps {
  position: Position;
  icon: IconKey;
  onClick: () => void;
  onHoverStart?: () => void;
  onHoverEnd?: () => void;
}

const Wrapper = styled(motion.div)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
`;

const Pill = styled(motion.div)`
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: all;
  transform: translate(-50%, -50%);
`;

export const ThreeSixtyInteractionToolTip: React.FC<
  ThreeSixtyInteractionToolTipProps
> = ({ position, icon, children, onClick, onHoverStart, onHoverEnd }) => {
  const { x, y } = position;
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.4, delay: 0.2 } }}
      exit={{ opacity: 0, transition: { duration: 0.4 } }}
    >
      <Wrapper
        animate={{ x: `${x}%`, y: `${y}%` }}
        transition={{ type: "spring", duration: 0.2 }}
      >
        <Pill>
          <Button
            icon={icon}
            color="hotPink"
            onClick={onClick}
            onHoverStart={onHoverStart}
            onHoverEnd={onHoverEnd}
          >
            {children}
          </Button>
        </Pill>
      </Wrapper>
    </motion.div>
  );
};
